<app-search-map
  class="search suggestions"
  [hideDetails]="true"
  [showFilters]="false"
></app-search-map>
<div class="address__footer">
  <button class="address__footer__button--secondary" (click)="suggest()">
    {{ 'suggestion.step.suggestions' | translate }}
  </button>
  <button class="address__footer__button" (click)="complete()">
    {{ 'suggestion.step.complete' | translate }}
  </button>
</div>
